import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../../footer.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";

const AddCoupon = () => {
  // State to keep track of selected coupon type
  const [couponType, setCouponType] = useState("multi-use");

  // Handle the change in dropdown selection
  const handleCouponTypeChange = (e) => {
    setCouponType(e.target.value);
  };

  return (
    <>
      {/* Logo */}
      <Header />
      <Navvbar/>
      <br />

      <div className="container">
        <div className="row">
          {/* Sidebar */}
          <div className="col-md-2" style={{ borderRight: "2px solid #004aad" }}>
                        <h3>Promotions</h3>
                        <div>
                            <div style={{ marginBottom: "10px" }}>
                                <Link to="/Websites" >DDX Websites</Link>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <Link to="/Ad" >DDX Ads</Link>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <Link to="/Coupon" >DDX Coupons</Link>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <Link to="/Widget" >Widgets</Link>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <Link to="/action" >Links</Link>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <Link to="/DDxAccount" >DDX Account Onboarding</Link>
                            </div>
                        </div>
                    </div>

          {/* Main Content */}
          <div className="col-md-10" style={{ paddingLeft: "20px" }}>
            <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
              <h2 style={{ marginBottom: "20px", fontWeight: "bold" }}>Add Coupon</h2>

              <div
                style={{
                  padding: "20px",
                  borderRadius: "5px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  width: "100%",
                  backgroundColor: "#f0f0f0",
                }}
              >
                {/* Coupon Type */}
                <div style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginBottom: "10px",
                      display: "block",
                      backgroundColor: "white",
                      color: "#004aad",
                      borderBottom: "3px solid #004aad",
                    }}
                  >
                    <h4>Coupon Type</h4>
                  </label>
                  <br />
                  <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "15px" }}>
                    {/* Label */}
                    <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "15px" }}>
                      {/* Label */}
                      <label
                        style={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                          display: "flex",
                          flexDirection: "column",
                          flex: "1", // Allow the label to take available space
                        }}
                      >
                        Type *
                      </label>

                      {/* Dropdown */}
                      <select
                        value={couponType}
                        onChange={handleCouponTypeChange}
                        style={{
                          width: "200px",  // Reduced width of the dropdown (you can adjust this value)
                          padding: "10px",
                          borderRadius: "5px",
                          border: "1px solid #004aad",
                          marginLeft: "330px",  // Remove margin to avoid excess space
                        }}
                      >
                        <option value="multi-use">Multi Use</option>
                        <option value="single-use">Single Use</option>
                      </select>
                    </div>
                    </div>


                  </div>

                  {/* Conditional Rendering Based on Coupon Type */}
                  {couponType === "multi-use" ? (
                    <>
                      {/* Multiple Use Coupon Fields */}
                      <h4
                        style={{
                          marginTop: "30px",
                          marginBottom: "20px",
                          color: "#004aad",
                          backgroundColor: "white",
                          borderBottom: "3px solid #004aad",
                        }}
                      >
                        Multiple Use Coupon
                      </h4>
                      <form>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                          {/* Max Uses */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Max Uses
                            </label>
                            <input
                              type="number"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Max Uses Per Practice */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Max Uses Per Practice
                            </label>
                            <input
                              type="number"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Customize All Checkbox */}
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: 1,
                              }}
                            >
                              Customize All
                            </label>
                            <input
                              type="checkbox"
                              style={{
                                transform: "scale(1.2)", // Adjust size of checkbox
                                cursor: "pointer",
                                marginLeft: "auto", // Push the checkbox to the right side
                                marginRight: "580px", // Adjust this value to move the checkbox slightly left
                              }}
                            />
                          </div>

                          {/* Code Prefix */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Code Prefix
                            </label>
                            <input
                              type="text"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Expiry Date */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Expiry *
                            </label>
                            <input
                              type="date"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Discount Type */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Discount Type *
                            </label>
                            <select
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                fontSize: "14px",
                                marginRight: "400px",
                              }}
                            >
                              <option value="percentage">Percentage</option>
                              <option value="fixed">Fixed Amount</option>
                            </select>
                          </div>

                          {/* Discount Amount */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Discount *
                            </label>
                            <input
                              type="number"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Promote with Ad Checkbox */}
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: 1,
                              }}
                            >
                              Promote with Ad
                            </label>
                            <input
                              type="checkbox"
                              style={{
                                transform: "scale(1.2)", // Adjust size of checkbox
                                cursor: "pointer",
                                marginLeft: "auto", // Push the checkbox to the right side
                                marginRight: "580px", // Adjust this value to move the checkbox slightly left
                              }}
                            />
                          </div>

                          {/* Procedure */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Procedure
                            </label>
                            <select
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                fontSize: "14px",
                                marginRight: "400px",
                              }}
                            >
                              <option value="">Select procedure</option>
                            </select>
                          </div>

                          {/* Load On To Accounts */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Load On To Accounts' Lists
                            </label>
                            <select
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                fontSize: "14px",
                                marginRight: "400px",
                              }}
                            >
                              <option value="">Select accounts</option>
                            </select>
                          </div>
                          {/* Save Button */}
                          <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                              type="submit"
                              style={{
                                backgroundColor: "#004aad",
                                color: "white",
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                marginTop: "15px",
                                width: "10%",
                              }}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  ) : (
                    <>
                      {/* Single Use Coupon Fields */}
                      <h4
                        style={{
                          marginTop: "30px",
                          marginBottom: "20px",
                          color: "#004aad",
                          backgroundColor: "white",
                          borderBottom: "3px solid #004aad",
                        }}
                      >
                        Single Use Coupon
                      </h4>
                      <form>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                          {/* How Many */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              How Many? *
                            </label>
                            <input
                              type="number"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Code Prefix */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Code Prefix
                            </label>
                            <input
                              type="text"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Expiry Date */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Expiry *
                            </label>
                            <input
                              type="date"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Discount Type */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Discount Type *
                            </label>
                            <select
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                fontSize: "14px",
                                marginRight: "400px",
                              }}
                            >
                              <option value="percentage">Percentage</option>
                              <option value="fixed">Fixed Amount</option>
                            </select>
                          </div>

                          {/* Discount Amount */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Discount *
                            </label>
                            <input
                              type="number"
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                marginRight: "400px",
                              }}
                            />
                          </div>

                          {/* Procedure */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Procedure
                            </label>
                            <select
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                fontSize: "14px",
                                marginRight: "400px",
                              }}
                            >
                              <option value="">Select procedure</option>
                            </select>
                          </div>

                          {/* Load On To Accounts */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left", // Align label to the left
                                flex: "1",
                              }}
                            >
                              Load On To Accounts' Lists
                            </label>
                            <select
                              style={{
                                width: "20%",
                                padding: "10px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginTop: "5px",
                                fontSize: "14px",
                                marginRight: "400px",
                              }}
                            >
                              <option value="">Select accounts</option>
                            </select>
                          </div>
                          {/* Save Button */}
                          <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                              type="submit"
                              style={{
                                backgroundColor: "#004aad",
                                color: "white",
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                marginTop: "15px",
                                width: "10%",
                              }}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            <div className="container">
                <Footer />
            </div>
      </>
      );
};

      export default AddCoupon;
